import React from "react";

const StaffDetailsModal = ({ isOpen, onClose, staffDetails }) => {
  if (!isOpen) return null;

  const formatDate = (dateString) => {
    if (!dateString) return "—";
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const fields = staffDetails
    ? [
        { label: "Full Name", value: staffDetails.full_name },
        { label: "Designation", value: staffDetails.role_name },
        { label: "Gender", value: staffDetails.gender },
        {
          label: "Date of Birth",
          value: formatDate(staffDetails.date_of_birth),
        },
        { label: "CNIC", value: staffDetails.cnic },
        { label: "Phone No.", value: staffDetails.contact_number },
        { label: "Email", value: staffDetails.email },
        { label: "Qualification", value: staffDetails.qualification },
        { label: "Address", value: staffDetails.address },
        {
          label: "Date of Appointment",
          value: formatDate(staffDetails.hire_date),
        },
        {
          label: "Monthly Salary",
          value: staffDetails.salary
            ? `PKR ${Number(staffDetails.salary).toLocaleString()}`
            : "—",
        },
      ]
    : [];

  return (
    <div
      className="fixed inset-0 bg-black/50 flex justify-center items-center z-50 p-2 sm:p-6"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl shadow-2xl w-full max-w-[70%] max-h-[94vh]  flex flex-col overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* ── Header ── */}
        <div className="bg-[#215187] px-4 py-3 sm:px-5 sm:py-4 flex items-center justify-between flex-shrink-0">
          <div className="min-w-0 mr-3">
            <p className="text-[10px] font-medium uppercase tracking-widest text-gray-400">
              Staff Profile
            </p>
            {/* truncate prevents long names breaking layout on tiny screens */}
            <p className="text-white font-semibold text-sm sm:text-base leading-tight mt-0.5 truncate">
              {staffDetails?.full_name || "Staff Member"}
            </p>
          </div>
          <button
            onClick={onClose}
            className="flex-shrink-0 flex items-center justify-center w-8 h-8 rounded-full
              bg-white/10 text-gray-300 hover:bg-white/20 hover:text-white
              transition-all duration-200 text-lg font-bold leading-none"
          >
            &times;
          </button>
        </div>

        {/* ── Avatar strip ── */}
        <div className="bg-gray-50 border-b border-gray-100 px-4 py-2.5 sm:px-5 sm:py-3 flex items-center gap-2 sm:gap-3 flex-shrink-0">
          {/* Avatar circle */}
          <div
            className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-[#215187] flex items-center justify-center
            text-white font-bold text-sm flex-shrink-0"
          >
            {staffDetails?.full_name?.charAt(0)?.toUpperCase() || "S"}
          </div>

          {/* Role + email — min-w-0 + truncate prevents overflow pushing badge off screen */}
          <div className="min-w-0 flex-1">
            <p className="text-xs sm:text-sm font-semibold text-gray-800 truncate">
              {staffDetails?.role_name || "—"}
            </p>
            <p className="text-[11px] text-gray-400 truncate">
              {staffDetails?.email || "—"}
            </p>
          </div>

          {/* Badge — flex-shrink-0 so it never disappears on small screens */}
          <span
            className="flex-shrink-0 text-[10px] sm:text-[11px] font-semibold
            px-2 py-0.5 sm:px-2.5 sm:py-1 rounded-full
            bg-green-50 text-green-600 border border-green-100 whitespace-nowrap"
          >
            Active
          </span>
        </div>

        {/* ── Scrollable details grid ── */}
        <div className="overflow-y-auto flex-1 px-3 py-3 sm:px-5 sm:py-4">
          {staffDetails ? (
            // 1 col on phones/fold-closed, 2 cols on fold-open/tablet+
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3">
              {fields.map(({ label, value }) => (
                <div
                  key={label}
                  className="bg-gray-50 border border-gray-100 rounded-xl px-3 py-2.5 sm:px-4 sm:py-3"
                >
                  <p className="text-[9px] sm:text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-0.5 sm:mb-1">
                    {label}
                  </p>
                  <p className="text-xs sm:text-sm font-medium text-gray-800 break-words leading-snug">
                    {value || "—"}
                  </p>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-10 text-gray-400 text-sm">
              No details available.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StaffDetailsModal;
